(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.nl = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    el: {
      autocomplete: {
        noDataMessage: 'Geen gegevens gevonden'
      },
      combobox: {
        placeholder: 'Selecteren',
        searchPlaceholder: 'Zoeken'
      },
      datepicker: {
        apply: 'Toepassen',
        clearSelection: 'Wissen',
        pickADays: 'Dagen selecteren',
        prevYear: 'Vorig jaar',
        nextYear: 'Volgend jaar',
        prevMonth: 'Vorige maand',
        nextMonth: 'Volgende maand',
        year: '',
        month1: 'Januari',
        month2: 'Februari',
        month3: 'Maart',
        month4: 'April',
        month5: 'Mei',
        month6: 'Juni',
        month7: 'Juli',
        month8: 'Augustus',
        month9: 'September',
        month10: 'Oktober',
        month11: 'November',
        month12: 'December',
        weeks: {
          sun: 'Zo',
          mon: 'Ma',
          tue: 'Di',
          wed: 'Wo',
          thu: 'Do',
          fri: 'Vr',
          sat: 'Za'
        },
        months: {
          jan: 'Jan',
          feb: 'Feb',
          mar: 'Mrt',
          apr: 'Apr',
          may: 'Mei',
          jun: 'Jun',
          jul: 'Jul',
          aug: 'Aug',
          sep: 'Sep',
          oct: 'Okt',
          nov: 'Nov',
          dec: 'Dec'
        },
        pickADay: 'Selecteer een dag'
      },
      timepicker: {
        meridiemAM: 'AM',
        meridiemPM: 'PM'
      },
      dropdown: {
        noDataMessage: 'Geen gegevens gevonden'
      },
      filepicker: {
        browse: 'Bladeren',
        select: 'Een bestand selecteren'
      },
      filter: {
        apply: 'Toepassen',
        cancel: 'Annuleren',
        filterButton: 'Filter',
        reset: 'Filters opnieuw instellen',
        resetDefault: 'Terugzetten naar standaardwaarden'
      },
      search: {
        noDataMessage: 'Geen gegevens gevonden'
      },
      'multi-search': {
        'separator-and': 'EN',
        'search-button': 'Zoeken',
        'search-placeholder': 'Zoeken op naam'
      },
      select: {
        all: 'Alles',
        clearSelection: 'Selectie wissen',
        noMatch: 'Geen gegevens gevonden',
        noData: 'Geen gegevens',
        placeholder: 'Selecteren',
        item: 'item(s)',
        selected: 'geselecteerd',
        found: 'gevonden'
      },
      upload: {
        browseButton: 'Bladeren',
        text: 'Sleep bestanden om te uploaden, of klik op \'Bladeren\'',
        tip: 'U kunt 10 bestanden van elk maximaal 25 MB uploaden'
      },
      table: {
        emptyText: 'Geen gegevens'
      },
      tree: {
        emptyText: 'Geen gegevens'
      }
    }
  };
  _exports.default = _default;
});